import request from "@/utils/request";
import Qs from "qs";

// 党员申请列表
export function apply_list(data) {
  return request({
    url: "/party/apply_list",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 党员申请通过
export function audit_pass(data) {
  return request({
    url: "/party/audit_pass",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 党员申请拒绝
export function audit_refuse(data) {
  return request({
    url: "/party/audit_refuse",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 查看拒绝原因
export function refuse_view(data) {
  return request({
    url: "/party/refuse_view",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 省份列表
export function get_province(data) {
  return request({
    url: "/party/get_province",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 通过省份获取城市
export function get_city(data) {
  return request({
    url: "/party/get_city",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 通过城市获取区域列表
export function get_area(data) {
  return request({
    url: "/party/get_area",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 党建列表
export function building_list(data) {
  return request({
    url: "/party/building_list",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 党建添加
export function building_add(data) {
  return request({
    url: "/party/building_add",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 党建编辑
export function building_edit(data) {
  return request({
    url: "/party/building_edit",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 党建详情
export function building_info(data) {
  return request({
    url: "/party/building_info",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 党建删除
export function building_del(data) {
  return request({
    url: "/party/building_del",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 改变发布状态
export function building_status(data) {
  return request({
    url: "/party/building_status",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 党员列表
export function party_list(data) {
  return request({
    url: "/party/party_list",
    method: "post",
    data: Qs.stringify(data),
  });
}

// 活动列表
export function activity_lists(data) {
  return request({
    url: "/common/activity_lists",
    method: "post",
    data: Qs.stringify(data),
  });
}


// 党员删除
export function partyDel(data) {
  return request({
    url: "/party/del",
    method: "post",
    data: Qs.stringify(data),
  });
}